import jQuery from 'jquery'
import 'jquery-validation';
import {ScrollTrigger} from 'gsap/ScrollTrigger';
import CustomAnimation from "src/scripts/animation/customAnimation";
import {gsap} from "gsap";

const customAnmation = new CustomAnimation();

class Register {
  constructor() {
  }

  init() {
    this.initPage();
    this.initParallax();
    this.initForm();
  }

  initPage = () => {
  }

  initParallax = () => {
    gsap.registerPlugin(ScrollTrigger);

    customAnmation.animateHeaderImage('.header');
    customAnmation.animateFromBottom('.form-group');
    customAnmation.animateButtonGroup('.button');

  }

  initForm = () => {
    this.resetForm();
    const isFrench = document.documentElement.lang === 'fr';

    document.getElementById('proofofpurchase').addEventListener('change', async function (event) {
      const fileInput = event.target;
      const label = document.querySelector('label[for="proofofpurchase"]');
      if (fileInput.files.length > 0) {
        fileInput.setAttribute('uploading', 'true');
        if (fileInput.files[0].size > 10 * 1024 * 1024) {
          label.textContent = isFrench ? 'Fichier trop volumineux (max. 10 Mo)' : 'Datei zu groß (max. 10MB)';
          fileInput.value = "";
          fileInput.removeAttribute('uploading');
          return;
        }
        label.textContent = 'Uploading...';
        try {
          /* eslint-disable-next-line no-inner-declarations */
          async function uploadToS3(presigned) {
            const form = new FormData();
            Object.entries(presigned.fields).forEach(([k, v]) => form.append(k, v));
            form.append("file", fileInput.files[0]); // <input type="file" id="fileInput">

            const res = await fetch(presigned.url, {
              method: "POST",
              contentType: null,
              body: form,
            });

            if (!res.ok) {
              const text = await res.text(); // S3-Fehlermeldung (XML) lesen
              throw new Error(`S3 upload failed: ${res.status} ${text}`);
            }
            // Erfolg = i.d.R. HTTP 204, ETag in Headern
            console.log("OK. Key:", presigned.fields.key);
            return presigned.fields.key;
          }
          jQuery.ajax({
            type: 'POST',
            url: 'https://wfezsg4welriopfg4diiwmw77m0nxvmz.lambda-url.eu-central-1.on.aws/',
            contentType: "application/json; charset=utf-8",   // wir senden JSON
            dataType: "json",                                // wir erwarten JSON zurück
            data: JSON.stringify({
              filename: fileInput.files[0].name
            }),
          }).done(function (signedUrl) {
            uploadToS3(signedUrl).then((key) => {
              label.textContent = `${fileInput.files[0].name} erfolgreich hochgeladen`;
              fileInput.removeAttribute('uploading');
              fileInput.setAttribute('key', key);

            }).catch(err => {
              console.log(err)
              label.textContent = 'Upload fehlgeschlagen: ' + err;
              fileInput.value = "";
              fileInput.removeAttribute('uploading');
            });


          }).catch(err => {
            console.log(err);
            label.textContent = 'Upload fehlgeschlagen: ' + err.responseText;
            fileInput.value = "";
            fileInput.removeAttribute('uploading');
          })


        } catch (err) {
          console.log(err)
          label.textContent = 'Upload fehlgeschlagen: ' + err;
          fileInput.value = "";
          fileInput.removeAttribute('uploading');
        }

      } else {
        label.textContent = 'Upload Kaufbeleg Ambilight TV';
      }
    });

    const that = this;
    const formMessages = jQuery('#form-messages');

    const messagesDe = {
      proofofpurchase: 'Bitte wähle deinen Kaufbeleg aus.',
      gender: 'Bitte gib dein Geschlecht ein.',
      firstname: 'Bitte gib deinen Vornamen ein.',
      lastname: 'Bitte gib deinen Nachnamen ein.',
      email: 'Bitte gib deine korrekte E-Mail ein.',
      email_repeat: 'Bitte gib deine korrekte E-Mail erneut ein.',
      street: 'Bitte gib deine Strasse ein.',
      street_number: 'Bitte gib deine Hausnummer ein.',
      postcode: 'Bitte gib deine Postleitzahl ein.',
      city: 'Bitte gib deinen Ort ein.',
      phone: 'Bitte gib deine Telefonnummer ein.',
      country: 'Bitte gib dein Land ein.',

      modelnumber: 'Bitte gib die Modellnummer/Typenbezeichnung ein.',
      serialnumber: 'Bitte gib die Seriennummer ein.',
      bank: 'Bitte gib dein Bankinstitut ein.',
      iban: 'Bitte gib deine IBAN ein.',

      retailer: 'Bitte wähle einen Händler aus.',
      referral: 'Bitte wähle aus, wie du auf die Aktion aufmerksam geworden bist.',

      participation: 'Bitte akzeptiere die Teilnahmebedingungen und Datenschutzbestimmungen.',
      analysis: 'Bitte akzeptiere die Bedingungen.'
    };

    const messagesFr = {
      proofofpurchase: 'Veuillez sélectionner votre preuve d’achat.',
      gender: 'Veuillez indiquer votre sexe.',
      firstname: 'Veuillez indiquer votre prénom.',
      lastname: 'Veuillez indiquer votre nom de famille.',
      email: 'Veuillez saisir une adresse e-mail valide.',
      email_repeat: 'Veuillez saisir à nouveau votre adresse e-mail.',
      street: 'Veuillez indiquer votre rue.',
      street_number: 'Veuillez indiquer votre numéro de rue.',
      postcode: 'Veuillez indiquer votre code postal.',
      city: 'Veuillez indiquer votre ville.',
      phone: 'Veuillez indiquer votre numéro de téléphone.',
      country: 'Veuillez indiquer votre pays.',

      modelnumber: 'Veuillez indiquer le numéro de modèle ou la désignation du type.',
      serialnumber: 'Veuillez indiquer le numéro de série.',
      bank: 'Veuillez indiquer votre banque.',
      iban: 'Veuillez saisir votre IBAN.',

      retailer: 'Veuillez sélectionner un revendeur.',
      referral: 'Veuillez indiquer comment vous avez entendu parler de l’offre.',

      participation: 'Veuillez accepter les conditions de participation et la politique de confidentialité.',
      analysis: 'Veuillez accepter les conditions.',
    };

    jQuery("#registration").validate({

      rules: {
        proofofpurchase: 'required',
        gender: 'required',
        firstname: 'required',
        lastname: 'required',
        email: {
          required: true,
          email: true
        },
        email_repeat: {
          required: true,
          email: true,
          equalTo: '#email'
        },
        street: 'required',
        street_number: 'required',
        postcode: 'required',
        city: 'required',
        phone: 'required',
        country: {
          required: true
        },
        modelnumber: 'required',
        serialnumber: 'required',
        retailer: {
          required: true
        },
        referral: {
          required: true
        },
        participation: 'required'
      },
      messages: isFrench ? messagesFr : messagesDe,
      submitHandler(form) {
        const formData = jQuery(form).serializeArray().reduce((obj, item) => {
          obj[item.name] = item.value;
          return obj;
        }, {});

        formData['language'] = isFrench ? 'fr' : 'de';

        if (jQuery('#proofofpurchase')[0].hasAttribute('uploading')) {
          formMessages.text(isFrench ? 'Veuillez patienter pendant le téléchargement de la preuve d’achat.' : 'Bitte warten Sie, bis der Kaufbeleg hochgeladen wurde.');
          return
        } else if (jQuery('#proofofpurchase')[0].hasAttribute('key')) {
          formData['proofofpurchase'] = jQuery('#proofofpurchase').attr('key');
        }

        that.submitForm(formData, formMessages);
      }
    });
  }

  submitForm(formData, formMessages) {
    jQuery('.button_form_send').addClass('button_loading');
    jQuery.ajax({
      type: 'POST',
      url: 'https://3zpj4j6vgcnas5ld23mtugd5h40fqkok.lambda-url.eu-central-1.on.aws/',
      data: JSON.stringify(formData),
      contentType: 'application/json',
      dataType: 'json',
      processData: false,
    })
      .done(function (response) {
        if(response){ // check whether response is received
          window.location.href = "thankyou.html";
        }
        formMessages.text(response.message);
      })
      .fail(function (data) {
        formMessages.text(data.message || 'Oops! An error occurred and your message could not be sent.');
      });
  }

  resetForm_dummy() {
    jQuery('#proofofpurchase').val('');
    jQuery('#gender').val('männlich');
    jQuery('#firstname').val('Sebastian');
    jQuery('#lastname').val('Annies');
    jQuery('#email').val('Sebastian.Annies@gmail.com');
    jQuery('#email_repeat').val('Sebastian.Annies@gmail.com');
    jQuery('#street').val('Bei der Apostelkriche');
    jQuery('#street_number').val('12');
    jQuery('#postcode').val('20257');
    jQuery('#city').val('Hamburg');
    jQuery('#phone').val('0123 456789');
    jQuery('#country').val('deutschland');

    jQuery('#modelnumber').val('TR2345678');
    jQuery('#serialnumber').val('21345678');
    //jQuery('#bank').val('Haspa');
    //jQuery('#iban').val('DE49 4444 4444 4444 4444 44');

    jQuery('#retailer').val('Mediamarkt');
    jQuery('#referral').val('Philips Webseite');

    jQuery('#participation').prop('checked', true);
    jQuery('#analysis').prop('checked', true);
  }

  resetForm() {
    jQuery('#proofofpurchase').val('');
    jQuery('#gender').val('');
    jQuery('#firstname').val('');
    jQuery('#lastname').val('');
    jQuery('#email').val('');
    jQuery('#email_repeat').val('');
    jQuery('#street').val('');
    jQuery('#street_number').val('');
    jQuery('#postcode').val('');
    jQuery('#city').val('');
    jQuery('#phone').val('');
    jQuery('#country').val('');

    jQuery('#modelnumber').val('');
    jQuery('#serialnumber').val('');
    //jQuery('#bank').val('');
    //jQuery('#iban').val('');

    jQuery('#retailer').val('');
    jQuery('#referral').val('');


    jQuery('#participation').prop('checked', false);
    jQuery('#analysis').prop('checked', false);
  }
}

export default Register;
